import { createClient } from "@/utils/supabase/client";
import type { Membership } from './types';

export async function getMembership(userId: string): Promise<Membership> {
  const supabase = await createClient();
  const { data, error } = await supabase
    .from('profiles')
    .select('membership')
    .eq('user_id', userId)
    .single();

  if (error || !data) {
    return null;
  }
  
  return data.membership as Membership;
}